module.exports = __webpack_public_path__ + "img/download.b88164e4.png";